import Vue from 'vue';
// import Vuetify from 'vuetify';
import VueCurrencyInput from 'vue-currency-input';
import VCalendar from 'v-calendar';
import VueMask from 'v-mask';
import AxiosPlugin from './plugins/AxiosPlugins';
import App from './App.vue';
import router from './router';
import store from './store';
import '../node_modules/bulma/css/bulma.css';
import 'vuetify/dist/vuetify.min.css';
import Filters from './filters/filters';

const pluginOptions = {
  globalOptions: { currency: 'USD', locale: 'en-CA' },
};

Vue.use(VueCurrencyInput, pluginOptions);
Vue.use(VCalendar, {
  componentPrefix: 'vc', locale: 'es-CA',
});
Vue.use(VueMask);
Vue.mixin({ filters: Filters });
Vue.config.productionTip = false;
// Vue.use(Vuetify);
Vue.use(AxiosPlugin);

// const primary = '#122870';

new Vue({
  router,
  store,
  render: h => h(App),
  // vuetify: new Vuetify({
  //   theme: {
  //     light: true,
  //     themes: {
  //       light: {
  //         primary,
  //         secondary: '#b0bec5',
  //         accent: '#0056a8',
  //         error: '#b71c1c',
  //       },
  //     },
  //   },
  // }),
}).$mount('#app');
